import type { Components } from 'react-markdown';
import ReactMarkdown from 'react-markdown';
import remarkGfm from 'remark-gfm';

const ALLOWED_LINK_PROTOCOLS = new Set(['http:', 'https:', 'mailto:']);

/** Safe href for markdown links — blocks javascript: and other non-http schemes. */
export function safeMarkdownHref(href: string | undefined): string | undefined {
  if (!href) return undefined;
  try {
    const url = new URL(href, 'https://voicer.local');
    if (!ALLOWED_LINK_PROTOCOLS.has(url.protocol)) return undefined;
    return href;
  } catch {
    return undefined;
  }
}

const markdownComponents: Components = {
  a({ href, children }) {
    const safe = safeMarkdownHref(href);
    if (!safe) return <span>{children}</span>;
    return (
      <a href={safe} target="_blank" rel="noopener noreferrer">
        {children}
      </a>
    );
  },
};

/** Renders assistant chat content as GitHub-flavored markdown (no raw HTML). */
export function MarkdownMessage({ text }: Readonly<{ text: string }>): React.ReactNode {
  if (!text) return <span className="dim">…</span>;
  return (
    <div className="md-body">
      <ReactMarkdown remarkPlugins={[remarkGfm]} components={markdownComponents}>
        {text}
      </ReactMarkdown>
    </div>
  );
}

/** Prefer live streaming text when it is ahead of the persisted assistant message. */
export function assistantDisplayText(
  content: string,
  streaming: { turnId: string; text: string } | null | undefined,
  turnId: string,
): string {
  if (streaming?.turnId === turnId && streaming.text.length >= content.length) {
    return streaming.text;
  }
  return content;
}
